import { Metamodel } from 'app/model/base/model';
import { TabularTypeSettings } from './tabular-type-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { SnowflakeTableDataset } from 'shell-models-lib';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';
import { DataFlowExpression } from '../dataflowexpression';
import { BooleanDataFlowType } from '../dataflow-datatype';

@Metamodel.model({
    name: adfModelTypeMap.snowflake.dataflowSettings
})
export class SnowflakeSettings extends TabularTypeSettings {

    @Metamodel.attribute({
        display: stringResources.SystemColumnsLabel
    })
    public systemColumns: DataFlowExpression;

    @Metamodel.attribute({
        display: stringResources.DataFlowEnableSQLNativeCDCNetChangesLabel
    })
    public netChanges: DataFlowExpression;

    public override get isDatabaseNameRequired(): boolean {
        return __IS_FABRIC_MDF__;
    }

    public initialize(subFormat: string): void {
        this.systemColumns = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'true');
        this.netChanges = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        super.initialize(subFormat);
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Snowflake;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getDatasetType(): string {
        return Metamodel.modelFor(SnowflakeTableDataset).name;
    }

    public getIconClass(): string {
        return 'i-100x100-SnowFlake';
    }
}
